// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__uWpBP","Sides":"Page_Sides__pMXFg","Left":"Page_Left__+tgqx","Right":"Page_Right__SUGgX","LHead":"Page_LHead__mjX0B","LTitle":"Page_LTitle__OfHkC"};